
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import type { AgencyAnalyticsData } from './useAgencyAnalytics';
import { Json } from '@/integrations/supabase/types';

export const useRentalAgencyAnalytics = () => {
  return useQuery<AgencyAnalyticsData, Error>({
    queryKey: ['rentalAgencyAnalytics'],
    queryFn: async () => {
      const { data, error } = await supabase
        .rpc('get_rental_agencies_analytics');
      
      if (error) throw new Error(error.message);
      
      if (!data) {
        throw new Error('No data returned from analytics function');
      }
      
      // First convert to unknown, then assert as AgencyAnalyticsData
      // This helps TypeScript understand our data structure
      return data as unknown as AgencyAnalyticsData;
    }
  });
};
